<template>
  <b-container fluid>
    <h3>Book a 20 minute demo</h3>
    <p>We'll explore if Vidon is right for you and your team</p>

    <span class="hs-cta-wrapper" id="hs-cta-wrapper-f68bb94f-9752-41af-b24b-593467f8d309"><span class="hs-cta-node hs-cta-f68bb94f-9752-41af-b24b-593467f8d309" id="hs-cta-f68bb94f-9752-41af-b24b-593467f8d309"><!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]--><a href="https://cta-redirect.hubspot.com/cta/redirect/8904915/f68bb94f-9752-41af-b24b-593467f8d309"  target="_blank" ><img class="hs-cta-img" id="hs-cta-img-f68bb94f-9752-41af-b24b-593467f8d309" style="border-width:0px;" src="https://no-cache.hubspot.com/cta/default/8904915/f68bb94f-9752-41af-b24b-593467f8d309.png"  alt="Book a demo"/></a></span></span>

  </b-container>
</template>

<script>

import { db, auth, _firebase } from '@/main.js'
import AuthMixin from "@/mixins/Auth.js"

export default {
  metaInfo: {title: 'Login demo'},
  props: ['profile'],
  mounted() {
    // eslint-disable-next-line
    $.getScript('https://js.hscta.net/cta/current.js', () => {
      window.hbspt.cta.load(8904915, 'f68bb94f-9752-41af-b24b-593467f8d309', {"region":"na1"});
    })
  }
}
</script>

<style scoped>

</style>
